export const SET_PERMISSIONS = 'SET_PERMISSIONS'

